import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      padding: spacing(6),
      backgroundColor: colors.grey.body,
      borderRadius: 8,
    },
    heading: {
      fontSize: 18,
      fontWeight: 500,
      color: colors.black.darker,
    },
    autocomplete: {
      margin: spacing(4, 0),
      width: '100%',
    },
    autocompleteOptions: {
      padding: spacing(2, 0),
    },
    autocompleteNotFound: {
      display: 'block',
      margin: spacing(2, 4),
    },
    autocompleteActionRow: {
      padding: spacing(4),
    },
    createCompanyBtn: {
      height: 32,
    },
    manuallyCreateText: {
      color: colors.black.darker,
      fontSize: 14,
    },
    manuallyCreateBtn: {
      marginTop: spacing(3),
      height: 32,
      width: 'fit-content',
    },
  });
